import kpiDeltaIcon from "@/assets/figma/store-overview/kpi-delta.svg";

interface Kpi {
  key: string;
  label: string;
  value: string;
  delta: string | null;
  comparisonHint: string;
}

export function KpiSection({ kpis }: { kpis: readonly Kpi[] }) {
  return (
    <section aria-label="关键经营指标" className="overview-panel-kpis">
      {kpis.map((kpi, index) => (
        <article className="overview-panel-kpi" data-primary={index === 0 || undefined} key={kpi.key}>
          <h3>{kpi.label}</h3>
          <strong>{kpi.value}</strong>
          <p>
            {kpi.delta ? <span className="overview-panel-kpi__delta"><img alt="" aria-hidden="true" src={kpiDeltaIcon} />{kpi.delta}</span> : null}
            <span>{kpi.comparisonHint}</span>
          </p>
        </article>
      ))}
    </section>
  );
}
